<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <!-- <admin-sidebar-menu v-if="admin" /> -->
    <div class="content-wrapper">
    <div class="container-wrapper center">
    <div class="content-main-wrapper signin-form add_account_form center">
    <div><h3 class="d-inline heading">{{ getFormTitle() }}</h3></div>
    <div class="heading-seperator"></div>
      <form @submit.prevent="onSubmit">
		<div class="row margin-bottom-15">
		  <div class="col-12 col-sm-12 p-0">
      <div class="col-6 float-left" style="padding-right: 30px;">
      <div class="col-12 p-0" style="margin-top: 10px;">
			<label
					for="first_name"
					class="col-12">First name: <span class="required">*</span></label>
			<input
					type="first_name"
					name="first_name"
					id="first_name"
					class="col-12 col-sm-12 input-height-35 form-control"
					ref="first_name"
					v-validate="{ rules: { required: true, regex: nameRegex() } }"
					v-model="first_name"
          data-vv-as="First name"
          maxlength="180">
			<div v-if="verrors.firstByRule('first_name', 'required')" class="validate-warning-msg">First Name is required</div>
      <div v-if="verrors.firstByRule('first_name', 'regex')" class="validate-warning-msg">First Name should only contain - and _</div>
      </div>
      <div class="col-12 p-0" style="margin-top: 10px;">
      <label
          for="email"
          class="col-12">Email address: <span class="required">*</span></label>
      <input
          type="email_addr"
          name="email"
          id="email_addr"
          class="col-12 col-sm-12 input-height-35 form-control"
          ref="email_addr"
          v-validate="'required|email'"
          v-model="email_addr"
          data-vv-as="Email address"
          maxlength="180">
      <div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
      </div>
      <div class="col-12 p-0" style="margin-top: 10px;">
      <label
          for="compensation"
          class="col-12">Starting Compensation: <span class="required">*</span></label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">$</span>
            </div>
            <input
              type="text"
              name="compensation"
              id="compensation"
              class="form-control"
              ref="compensation"
              v-validate="'required|numeric'"
              v-model="compensation"
              data-vv-as="Starting Compensation"
              maxlength="5">
            <div class="input-group-append">
              <span class="input-group-text">/hr</span>
            </div>
          </div>
      <div v-show="verrors.has('compensation')" class="validate-warning-msg">{{ verrors.first('compensation') }}</div>
      </div>

      <div class="col-12 p-0" style="margin-top: -7px;">
      <label
          for="mentor"
          class="col-12"> Mentor(s): <span class="required">*</span></label>
          <div class="search-padd" id="mentor-group-wrapper">
            <multiselect v-model="mentor_assigned"
                :options="groups"
                track-by="value"
                label="text"
                placeholder="Select Mentor(s)"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                v-bind:name="'mentor_assigned[]'"
                v-bind:id="'mentor_assigned'"
                v-validate="'required'">
              <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ getMentorDisplayText(values.length, values) }}</span></template>
            </multiselect>
            <div v-if="verrors.firstByRule('mentor_assigned[]', 'required')" class="margin-bottom-5 validate-warning-msg">Mentor(s) is required</div>
            </div>

          </div>
          <div class="col-12 p-0"  v-if="assessments.length > 0" style="margin-top: 10px;">
            <label
                for="roles"
                class="col-12">Assign Assessments: </label>
            <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in assessments">
              <div class="chkboxwrapper">
                <input 
                  name="Assessment assigned"
                  :value="option.id" 
                  :id="option.id" 
                  type="checkbox" 
                  v-model="assessmentSelected"
                  >
                <label :for="option.name">{{ option.name }}</label>
              </div>
            </div>

            </div>



		  </div>
      <div class="col-6 float-left" style="padding-left: 30px;">

      <div class="col-12 p-0" style="margin-top: 10px;">
      <label
          for="last name"
          class="col-12">Last name: <span class="required">*</span></label>
      <input
          type="last_name"
          name="last_name"
          id="last_name"
          class="col-12 col-sm-12 input-height-35 form-control"
          ref="last_name"
          v-validate="{ rules: { required: true, regex: nameRegex() } }"
          v-model="last_name"
          data-vv-as="Last name"
          maxlength="180">
      <div v-if="verrors.firstByRule('last_name', 'required')" class="validate-warning-msg">Last Name is required</div>
      <div v-if="verrors.firstByRule('last_name', 'regex')" class="validate-warning-msg">Last Name should only contain - and _</div>

      </div>
      <div class="col-12 p-0" style="margin-top: 10px;">
      <label
          for="phone_number"
          class="col-12">Phone number: </label>
      <input
          type="phone_number"
          name="phone_number"
          id="phone_number"
          class="col-12 col-sm-12 input-height-35 form-control"
          ref="phone_number"
          @keyup="adminPhoneValid($event)"
          @blur="adminPhoneValid($event)"
          v-validate="{ rules: { regex: adminPhoneRegex() } }"
          v-model="phone_number"
          data-vv-as="Phone number"
          maxlength="14">
      <div v-if="verrors.has('phone_number')" class="validate-warning-msg">Phone number is invalid</div>
      </div>


      <div class="col-12 p-0" style="margin-top: 10px;">
      <label
          for="review_compensation"
          class="col-12">Review Compensation: <span class="required">*</span></label>
          <date-picker
            v-model="review_compensation"
            :disabled-date="notBeforeToday"
            format="MM/DD/YYYY"
            v-bind:clearable="false"
            v-bind:editable="false"
            input-class="col-12 col-sm-12 input-height-35 form-control"
            >
            <template v-slot:icon-calendar>
              <i class="fa fa-calendar red-color" aria-hidden="true"></i>
            </template>
          </date-picker>
      <div v-show="verrors.has('review_compensation')" class="validate-warning-msg">{{ verrors.first('review_compensation') }}</div>
      </div>


          <div class="col-12 p-0" style="margin-top: 10px;">
            <label
                for="roles"
                class="col-12">Assign Task Lists: <span class="required">*</span></label>
            <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in tasklists">
              <div class="chkboxwrapper">
                <input 
                  name="Tasklist assigned"
                  :value="option.id" 
                  :id="option.id" 
                  type="checkbox" 
                  v-model="tasklist_assigned"
                  v-validate="'required'">
                <label :for="option.name">{{ option.name }}</label>
              </div>
            </div>
            <div v-show="verrors.has('Tasklist assigned')" class="validate-warning-msg">{{ verrors.first('Tasklist assigned') }}</div>
         </div>




          <div class="col-12 p-0"  v-if="courses.length > 0" style="margin-top: 10px;">
            <label
                for="roles"
                class="col-12">Courses to be assigned: </label>
            <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in courses">
              <div class="chkboxwrapper">
                <input 
                  name="Course assigned"
                  :value="option.id" 
                  :id="option.id" 
                  type="checkbox" 
                  v-model="courseSelected"
                  >
                <label :for="option.name">{{ option.name }}</label>
              </div>
            </div>
         </div>




      </div>


		  </div>
		
    




            </div>


        <div class="submit margin-bottom-15" style="text-align: center;">
          <button type="submit" class="btn btn-info start-button-blue">{{ getButtonName() }}</button>
        </div>
      </form>
    </div>
    </div>
   </div>
  </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import Multiselect from 'vue-multiselect';

const today = new Date();
today.setHours(0, 0, 0, 0);

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
      mentor: '',
      password: '',
      pw_confirm: '',
      groups: [],
      tasklists: [],
      tasklist_assigned: [],
      accountId: '',
      compensation: '',
      review_compensation: today,
      mentor_assigned: [],
      mentorSelected: [],
      assessments: [],
      assessmentSelected: [],
      courses: [],
      courseSelected: [],
      accountItems: [],
      usertype_options: [],
      isFormAccess: false,
      user_type: '',
    };
  },
  beforeCreate() {
    axios('/mobile/manager/my-account-lists',
    {
      method: 'GET',
      params: {
        account_id: this.$store.state.user_accountid
      }
    })
    .then(resp => {
      this.accountItems = resp.data;
      if (this.$route.name == 'addapprentice' && (this.accountItems.program == 'Apprenticeship' || this.accountItems.program == 'Mentorship & Apprenticeship')) {
        this.isFormAccess = true;
      } else if (this.$route.name == 'addmentee' && (this.accountItems.program == 'Mentorship' || this.accountItems.program == 'Mentorship & Apprenticeship')) {
        this.isFormAccess = true;
      }
      
      if (!this.isFormAccess) {
        router.push('/forbidden');
      }
    })
    .catch(() => {
    });


      axios('/accountgroups',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
          }
        },
      )
      .then(response => {
          for(var i=0; i < response.data.length; i++) {
            var group = {value: response.data[i].id, text: response.data[i].groupName};
            this.groups.push(group);
          }
       })
      .catch(error => {

      });
      axios.get('/desktop/assessment-builder-lists', {
      params: {
         user_roles: (this.$route.name == "addapprentice") ? 'ROLE_APPRENTICE' : 'ROLE_MENTEE',
         accountId: this.$store.state.user_accountid
        }
      })
      .then(response =>  {
        this.assessments = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

      axios('/alltasklists-account',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
          }
        },
      )
      .then(response => {
            this.tasklists = response.data;
       })
      .catch(error => {

      });

      axios.get('/desktop/course-lists', {
      params: {
         user_roles: (this.$route.name == "addapprentice") ? 'ROLE_APPRENTICE' : 'ROLE_MENTEE',
         accountId: this.$store.state.user_accountid
        }
      })
      .then(response =>  {
        this.courses = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  methods: {
  nameRegex: function() {
    return /^[a-zA-Z-_ ']*$/;
  },
  adminPhoneRegex: function() {
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  },
  adminPhoneValid: function(event) {
    var phone_val = this.phone_number;
    this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  },
	onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        this.createMentee();
      })
      .catch(() => {

      });
	},
  createMentee() {
      //make axios call to the API
      for(var i=0; i < this.mentor_assigned.length; i++) {
        this.mentorSelected.push(this.mentor_assigned[i].value);
      }
      axios('/users',
        {
          method: 'POST',
          data: {
                 "username": this.email_addr,
                 "email": this.email_addr,
                 "roles": [(this.$route.name == "addapprentice") ? 'ROLE_APPRENTICE' : 'ROLE_MENTEE'],
                 "first_name": this.first_name,
                 "last_name": this.last_name,
                 "phone_number": this.phone_number,
                 "compensation": this.compensation,
                 "review_compensation": this.review_compensation,
                 "mentor": this.mentorSelected,
                 "enabled": true,
                 "tasklists_assigned": this.tasklist_assigned,
                 "assessments_assigned": this.assessmentSelected,
                 "course_assigned": this.courseSelected,
                 "signin_count": 0,
                 "account_id": this.$store.state.user_accountid,
                 "user_type": (this.$route.name == "addapprentice") ? 'apprentice' : 'mentee',
                 }
        },
      )
      .then(response => {
          this.flash({ message: response.data.successMsg, variant: 'success' });
          this.navigate('/manage-license');
       })
      .catch(error => {
          const fieldErrors =  [{}];
          // var errMsgObj = error.response.data.message;
          var errMsgObj = JSON.parse(error.response.data.message);
          Object.keys(errMsgObj).map(key => {
             var newFieldErr = {field:key, msg:errMsgObj[key]};
             fieldErrors.push(newFieldErr);
          });
          this.$validator.errors.add(fieldErrors);
       });
  },
  navigate(path) {
    router.push(path);
  },
    notBeforeToday(date) {
      return date < today;
    },
    getMentorDisplayText(count, name) {
      if (count == 1) {
          return name[0].text;
      } else {
          var num = (count - 1);
          if (count > 2) {
              var otherText = num + " Others";
          } else {
              var otherText = num + " Other";
          }
          return name[0].text + ", +" + otherText;
      }
    },
    getUserTypeOptions() {
      if (this.$route.name == "addapprentice") {
        this.usertype_options = [
          {value: '', text: 'Select User Type'},
          {value: 'apprentice', text: 'Apprentice'},
        ] 
      } else {
        this.usertype_options = [
          {value: '', text: 'Select User Type'},
          {value: 'mentee', text: 'Mentee'}
        ] 
      }
    },
    getFormTitle() {
      return (this.$route.name == "addapprentice") ? 'Add an Apprentice' : 'Add a Mentee';
    },
    getButtonName() {
      return (this.$route.name == "addapprentice") ? 'Add Apprentice' : 'Add Mentee';
    }
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu,
    DatePicker,
    Multiselect,
  },
  created: function() {
    this.accountId = this.$store.state.user_accountid;
    var roles = store.state.roles;
    this.admin = false;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
    this.getUserTypeOptions();
  },
}
</script>

<style scoped>
.start-button-blue {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 130px; 
}

.tasklist-assign-wrapper label {
  font-weight: normal;
}
.tasklist-assign-wrapper .chkboxwrapper {
  margin-bottom: 5px;
}
.mx-datepicker {
  width: 100%;
}
.signin-form input {
  border: 1px solid #ced4da;
}
.content-main-wrapper {
  width: 75% !important;
  background-color: #FFF !important;
  padding: 30px;
}
</style>
<style>
#mentor-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentor-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:14px;
  padding: 3px 15px !important;
  color: #495057 !important;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
  padding: 3px 15px !important;
  color: #495057 !important;
 }
.multiselect__tags, .multiselect__input, .multiselect__single {
    background-color: #FFF !important;
}
.multiselect__input, .multiselect__single {
  border: none !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/manager/add_mentee.vue